import analytics from './analytics';
import collections from './collections';
import colors from './colors';
import common from './common';
import dom from './dom';
import ecommerce from './ecommerce';
import environments from './environments';
import formats from './formats';
// import navigation from './navigation';
import network from './network';
import translations from './translations';
import swiper from './swiper';

export default {
    analytics,
    collections,
    colors,
    common,
    dom,
    ecommerce,
    environments,
    formats,
    // navigation,
    network,
    translations,
    swiper,
};
